import styled from 'styled-components';
import { DESKTOP_MIN_WIDTH } from '../../utils/device';
export const StyledProjectCard = styled.div`
  cursor: pointer;
  &.list-view {
    .ant-card-body {
      flex-direction: row;
      gap: 10px;
      img {
        height: auto;
        object-fit: cover;

        @media screen and (min-width: ${DESKTOP_MIN_WIDTH}) {
          width: 100px;
          max-height: 75px;
        }
      }
      .project-item__content-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        h4 {
          margin: 0;
          margin-bottom: 10px;
          -webkit-line-clamp: 1;
          &::first-letter {
            text-transform: uppercase;
          }
        }
      }
      .project-item__swiper-btns {
        display: flex;
        gap: 15px;
      }
    }
  }
  .project-item__desc-btn {
    color: ${({ theme }) => theme.button01};
    padding: 9px 14px;
    span {
      text-decoration: underline;
    }
  }
  &:hover {
    .project-item__swiper {
      .swiper-button-prev,
      .swiper-button-next {
        opacity: 1;
      }
    }
  }
  .project-item__swiper {
    .swiper-slide {
      img,
      .ant-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .swiper-button-prev,
    .swiper-button-next {
      opacity: 0;
      transition: 0.4s ease;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background-color: rgba(0, 0, 0, 0.6);
      &::after {
        font-size: ${({ theme }) => theme.p3Size};
        color: ${({ theme }) => theme.white};
      }
    }
    .swiper-pagination {
      .swiper-pagination-bullet {
        background-color: ${({ theme }) => theme.gray01};
        opacity: 0.5;
      }
      .swiper-pagination-bullet-active {
        background-color: ${({ theme }) => theme.gray01};
        opacity: 1;
      }
    }
  }
  .project-item__swiper-btns {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;

    .ant-tag {
      margin-inline-end: 0;
    }
  }
  .ant-card-body {
    height: 100%;
    display: flex;
    flex-direction: column;
    &::after {
      display: none;
    }
    .swiper.swiper-initialized {
      margin: unset;
    }
    &::before {
      display: none;
    }
  }

  &:hover,
  &.selected {
    .ant-card {
      border-color: ${({ theme }) => theme.brand02};
      box-shadow: 0px 12px 16px -4px #10182814;
    }
  }

  .project-item__content-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .project_title {
      font-size: ${({ theme }) => theme.p1Size};
      margin-top: 20px;
      margin-bottom: 20px;
      line-height: inherit;
    }
  }
  .disabled-button {
    cursor: not-allowed;
  }
  .swiper-wrapper {
    overflow-y: hidden !important;
  }
  .bordered {
    .ant-card {
      border-color: ${({ theme }) => theme.brand02} !important;
    }
  }
`;
